import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'approval-no-icon',
  templateUrl: './approval-no-icon.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ApprovalNoIconComponent {}

